<template lang="html">
  <transition name="modal-fade">
    <div class="modal-background">

      <div id="new-group-popup" class="container white-box text-center col-lg-4 col-md-4 col-sm-6 col-11" role="dialog" v-show="showAddNewGroup">
        <header>
          <h4>Navngiv samlingen</h4>
        </header>

        <section class="row">
        	<input id="new-group-name-input" class="col-6" placeholder="Samlingens navn" aria-label="Samlingens navn" v-model="newGroupName"/>
        </section>

        <footer>
          <button class="grey btn col-5" @click="toggleNewGroupPopup(false)">Annuller</button>
        	<button class="blue btn col-5" @click="addNewUserGroup">Tilføj</button>
        </footer>

      </div>

      <div id="group-add-item" class="white-box col-lg-4 col-md-4 col-sm-6 col-11" role="dialog" v-show="!showAddNewGroup">
        <div class="sr-only" id="sr-explain">Vælg hvilke af dine samlinger stedet skal være en del af.</div>
        <header class="text-center">
          <h4>Tilføj til samling</h4>
        </header>

      	<section>
          <div id="add-new-group-btn" class="col-12 text-center" @click="toggleNewGroupPopup(true)" tabindex="0">
            <span>Tilføj ny samling</span>
            <span class="material-icons grey-text" aria-hidden="true">add</span>
          </div>
      		<ul id="group-list">
            <li id="no-data" v-if="userGroups.length == 0">Du har ikke oprettet nogle samlinger endnu.</li>
            <template v-for="(group) in userGroups">
              <AddContentToUserGroupChild :userGroupData="group" :type="type" :id="id" @toggleItem="toggleGroupTargets"></AddContentToUserGroupChild>
            </template>
      		</ul>
      	</section>

      	<footer class="text-center">
      		<button class="grey btn col-5" @click="$emit('close');">Annuller</button>
      		<button class="blue btn col-5" @click="addToUserGroup();">Gem</button>
      	</footer>
      </div>

    </div>
  </transition>
</template>

<script>
import Profile from '@/assets/profile/Profile.js'
import AddContentToUserGroupChild from '@/components/profile/AddContentToUserGroupChild.vue'
import { EventBus } from '@/main.js'

export default {
  data() {
    return {
      userGroups: [],
      showAddNewGroup: false,
      newGroupName: '',
      addToGroups: [],
    }
  },
  components: {
    AddContentToUserGroupChild,
  },
  props: {
    type: {
      required: true,
    },
    id: {
      required: true,
    },
    img: {
      required: true,
    },
    name: {
      required: true,
    }
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      Profile.getUserData().then((data) => {
        this.userGroups = data.groups;
        this.$HelperFunctions.sortArrayByString(this.userGroups, 'name');
        this.$HelperFunctions.setScreenReaderFocus('sr-explain');
      });
    },

    toggleNewGroupPopup(bool) {
      this.showAddNewGroup = bool;
      if(bool) {
        this.$HelperFunctions.setScreenReaderFocus('new-group-name-input');
      }
      else {
        this.$HelperFunctions.setScreenReaderFocus('sr-explain');
      }
  	},

    addNewUserGroup() {
      Profile.createNewGroup(this.newGroupName);
      this.showAddNewGroup = false;
      this.getData();
    },

    toggleGroupTargets(id) {
      var itemRemoved = false;
      for(var i = 0; i < this.addToGroups.length; i++) {
        if(this.addToGroups[i] == id) {
          this.addToGroups.splice(i, 1);
          itemRemoved = true;
        }
      }
      if(!itemRemoved) {
        this.addToGroups.push(id)
      }
    },

    addToUserGroup() {
      var isLiked = Profile.checkIfItemIsLiked(this.type, this.id);
      if(!isLiked) {
        this.likeOptions = (this.type == 'place') ? {type: this.type, id: this.id, name: this.name, tagId: this.tagId, img: this.img} : {type: this.type, id: this.id, name: this.name, img: this.img};
        Profile.like(this.likeOptions).then((likeItem) => {
          this.addToSelectedGroups(likeItem);
        });
      }
      else {
        for(var i = 0; i < Profile.userData.likes.length; i++) {
          if(Profile.userData.likes[i].type == this.type && Profile.userData.likes[i].value == this.id) {
            var item = Profile.userData.likes[i];
      			this.addToSelectedGroups(item);
      		}
      	}
      }
    },
    addToSelectedGroups(itemToAdd) {
      for(var i in this.addToGroups) {
        for(var k in Profile.userData.groups) {
          if(this.addToGroups[i] == Profile.userData.groups[k].id) {
            var newGroupContent = Profile.userData.groups[k].likes;
            newGroupContent.push(itemToAdd);
            Profile.addContentToGroup(this.addToGroups[i], newGroupContent);
          }
        }
      }
      this.$emit('close');
      EventBus.$emit('updatedLikes');
    }
  },
}
</script>

<style lang="css" scoped>
  #group-add-item {
    padding: 10px;
  }

  #add-item-headline {
  	text-align: center;
  	border-bottom: 1px solid #ddd;
  }

  #group-list {
    position: relative;
  	max-height: 350px;
  	overflow-y: auto;
  	margin-bottom: 0px;
  }

  #no-data {
    width: 100%;
    height: 50px;
    line-height: 50px;
    vertical-align: middle;
    text-align: center;
    border-bottom: 1px solid #ddd;
  }

  footer {
    margin-top: 10px;
  }

  footer .btn:first-child {
    margin-right: 10px;
  }

  /*Add new group in popup*/
  #add-new-group-btn {
    padding: 5px 0px;
    font-size: 15px;
    text-transform: uppercase;
    color: #00708d;
    border-bottom: 1px solid #ddd;
    cursor: pointer;
  }

  #add-new-group-btn .material-icons {
    font-size: 21px !important;
    position: relative;
    top: 5px;
  }

  #new-group-popup {
    padding: 10px;
  }

  #new-group-name-input {
    display: block;
    margin-top: 2px;
    margin-bottom: 10px;
    margin-left: auto;
    margin-right: auto;
  }
</style>
